import React, { FC, useCallback, memo, use, useTransition } from "react";
import { IDoesFilterPassParams } from "ag-grid-community";
import { CustomFilterProps, useGridFilter } from "ag-grid-react";
import { Spin } from "antd";
import { RadioGroup, Radio } from "@heroui/radio";
import { FormattedMessage } from "react-intl";

import styles from "../../DocumentTable.module.scss";
import { GQL } from "@binale-tech/shared";
import { DmsDataContext } from "@dms/types/ContextTypes";
import { DocumentsApi } from "@dms/scripts/DocumentsApi";

export enum FilterAttachedValues {
    All = "all",
    Attached = "attached",
    NotAttached = "notAttached",
}

export const FilterAttached: FC<CustomFilterProps<GQL.IDocument>> = memo(params => {
    const { dmsRecordsData } = use(DmsDataContext);
    const [isPending, startTransition] = useTransition();
    const { model, onModelChange } = params;

    const doesFilterPass = useCallback(
        (nodeParams: IDoesFilterPassParams<GQL.IDocument>) => {
            if (model === FilterAttachedValues.All) {
                return true;
            }
            const isAttached = dmsRecordsData.accountingDocumentIds.has(nodeParams.data.key);
            if (model === FilterAttachedValues.Attached) {
                return isAttached;
            }
            if (model === FilterAttachedValues.NotAttached) {
                return !isAttached;
            }

            return true;
        },
        [model, dmsRecordsData]
    );

    const onRadioChange = useCallback(
        (value: FilterAttachedValues) => {
            startTransition(() => {
                onModelChange(value);
            });
        },
        [onModelChange]
    );

    useGridFilter({
        doesFilterPass,
    });

    return (
        <Spin spinning={isPending}>
            <div className={styles.filterDropdown}>
                <RadioGroup value={model ?? FilterAttachedValues.All} onValueChange={onRadioChange}>
                    <Radio value={FilterAttachedValues.All}>
                        <FormattedMessage id="app.dms.showAll" />
                    </Radio>
                    <Radio value={FilterAttachedValues.Attached}>
                        <FormattedMessage id="app.dms.isAttached" />
                    </Radio>
                    <Radio value={FilterAttachedValues.NotAttached}>
                        <FormattedMessage id="app.dms.isn'tAttached" />
                    </Radio>
                </RadioGroup>
            </div>
        </Spin>
    );
});
